import {
  FeatureCta,
  FeatureDetailSection,
  FeatureHero,
  FeaturePageShell,
} from "./_Shell";

export default function CallerMemory() {
  return (
    <FeaturePageShell>
      <FeatureHero
        title="Your AI remembers every caller"
        subtitle="Most businesses treat every call like it's the first. NeuroSphere remembers names, history, preferences, and past conversations — so your callers feel known."
      />

      <div className="max-w-3xl mx-auto px-6 space-y-6 pb-8">
        <FeatureDetailSection
          icon="ri-user-smile-line"
          title="Greets returning callers by name"
          description="When someone calls back, your AI recognizes them instantly. No more 'Can I get your name again?' — it picks up exactly where you left off."
        />
        <FeatureDetailSection
          icon="ri-history-line"
          title="Remembers every conversation"
          description="Every call is summarized and stored. Your AI knows what was discussed, what was promised, and what still needs follow-up."
        />
        <FeatureDetailSection
          icon="ri-brain-line"
          title="Gets smarter over time"
          description="The more calls your AI handles, the better it knows your callers. It learns names, preferences, and patterns — building a memory profile for every person who reaches out."
        />
      </div>

      <FeatureCta headline="Ready to give your business a memory?" />
    </FeaturePageShell>
  );
}
